import React from 'react';
const paths = {
  plus: <path d="M12 5v14M5 12h14"/>,
  edit: <><path d="m15 4 5 5M4 20l5-1L21 7a3 3 0 0 0-4-4L5 15l-1 5Z"/></>,
  trash: <><path d="M3 6h18M9 6V3h6v3M5 6l1 15h12l1-15M10 10v7m4-7v7"/></>,
  wallet: <><rect x="3" y="5" width="18" height="15" rx="3"/><path d="M17 5V3H6a3 3 0 0 0-3 3m18 5h-6v5h6m-4-2.5h.01"/></>,
  cooking: <><path d="M5 12h14a7 7 0 0 1-14 0Zm-1 0h16M8 21h8M8 8c-3-3 3-3 0-6m8 6c-3-3 3-3 0-6"/></>,
  grid: <><rect x="3" y="3" width="7" height="7" rx="2" /><rect x="14" y="3" width="7" height="7" rx="2" /><rect x="3" y="14" width="7" height="7" rx="2" /><rect x="14" y="14" width="7" height="7" rx="2" /></>,
  flag: <><path d="M5 21V4m0 0c5-5 9 5 15 0v11c-6 5-10-5-15 0" /><path d="M10 4v11m5-9v11M5 9c5-5 9 5 15 0" /></>,
  users: <><circle cx="9" cy="8" r="3" /><path d="M3 21v-3a6 6 0 0 1 12 0v3m1-16a3 3 0 0 1 0 6m2 4a5 5 0 0 1 3 5" /></>,
  info: <><circle cx="12" cy="12" r="9" /><path d="M12 11v6m0-10v1" /></>,
  arrow: <path d="M5 12h14m-6-6 6 6-6 6" />,
  trophy: <><path d="M7 3h10v6a5 5 0 0 1-10 0V3Zm5 11v7m-4 0h8M7 5H3v3a4 4 0 0 0 5 4m9-7h4v3a4 4 0 0 1-5 4" /></>,
  trend: <path d="m3 17 6-6 4 4 8-10m-6 0h6v6" />,
  clock: <><circle cx="12" cy="12" r="9" /><path d="M12 7v5l3 2" /></>,
  logout: <path d="M9 3H4v18h5m6-14 5 5-5 5m-6-5h11" />,
  check: <path d="m5 12 4 4L19 6" />,
  save: <><path d="M5 3h12l4 4v14H3V3h2Z" /><path d="M7 3v6h10V3M7 21v-8h10v8" /></>,
  bolt: <path d="m13 2-9 12h7l-1 8 10-13h-8l1-7Z" />,
  chart: <path d="M4 3v17h17M8 15v-4m5 4V7m5 8v-5" />,
};
export default function Icon({ name, size = 20, ...props }) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" {...props}>{paths[name] || paths.flag}</svg>;
}
